module.exports = __webpack_public_path__ + "static/img/bird.464ef4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/bird.png
// module id = OjSN
// module chunks = 0